import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weekday',
  standalone: false
})
export class WeekdayPipe implements PipeTransform {

  public transform(weekIndex: number): unknown {
    const date = this.getClosestMonday();
    date.setDate(date.getDate() + (weekIndex ));
    return date.toLocaleDateString(undefined, { weekday: 'short' });
  }

  private getClosestMonday() {
    const date = new Date();
    const currentDayIndex = date.getDay();
    const daysUntilMonday = (1 + 7 - currentDayIndex) % 7;
    date.setDate(date.getDate() + daysUntilMonday);
    return date;
  }
}
